
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as login2OIrr2I84f8zuDAn19RARQFnA8jCZYbY3P7TqLb0imsMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/auth/login.vue?macro=true";
import { default as addJEemy1zFQOW0LvoKTjPkZUNy1mxu_q1OkOnZQ1CvaMkMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/enterprise-directory/add.vue?macro=true";
import { default as fetch_45datatdb_UAaAqCnnRMmcmTdQfPZvS7_RvLD9lBCXgv6gqJoMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/examples/fetch-data.vue?macro=true";
import { default as form_451bwUNp_43Z_qV8TtgVzbFKqA5JDEh99FiPPl5RyFSr9cMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/examples/form-1.vue?macro=true";
import { default as form_452mmhkNX1jZM_o8ip3TeA_R_sJlxUZU0onXfsdTcwacHsMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/examples/form-2.vue?macro=true";
import { default as add5YeSMbz9XcVDfq1GO5UdjXy6vKi1Xi4_ZGuSmf43SvYMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/forms/add.vue?macro=true";
import { default as addWSBQxyfX_CbJ4E9Ktbj83bLFjjGxocgHow_uY0fHIX0Meta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/roles/add.vue?macro=true";
import { default as addyIKcbl4t1S_36q_GX1sGnCpPKajehCZmWYu_y2aeM3cMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/users/add.vue?macro=true";
import { default as distributionOHQgC1zQoYL_WgVZvR2utRuKBOxYuv3WX9S34kP_NI8Meta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/distribution.vue?macro=true";
import { default as doc_45watchingq6kvRyPnYBYBkWuoypyZYQYjE10FMGpbHQ0FD5raPf8Meta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/doc-watching.vue?macro=true";
import { default as escalated_45docso3aAxULEgAioWx735kQFWEj_Q4w6aVxPR1aM2UhTG80Meta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/escalated-docs.vue?macro=true";
import { default as inbox2QIdgzehmpmbO38Kb00CkvYhwNZvsgG8OZ6c9gOczdkMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/inbox.vue?macro=true";
import { default as pending_45signaturesFqPt_jSzEvqbR5DBwHZKp8F4m4TSqaAQ1S55aZmkxUEMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/pending-signatures.vue?macro=true";
import { default as rejected_45docscy86GyP3fgkUOlZhjG0jszbf6TsxTF9v7FNxX2lNvz4Meta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/rejected-docs.vue?macro=true";
import { default as slot_45slaj0F3IBGEAKgYJhZsWfxyWLOLKsK1V131rRvfDnK_GboMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/slot-sla.vue?macro=true";
import { default as workflow_45slaIDXUzjSEyo43K8A9XiLsX4oL4_rAyREl5_MYZMVXD3UMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/workflow-sla.vue?macro=true";
import { default as adde3dX4Tadrod8nK7sU0onBJKhprUf8c4GTd_CRqwx9mAMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/distribution-group/add.vue?macro=true";
import { default as addm0HXnx4JqGrGocZZuelehsJc3NSSATV5m2u8vU49P_wMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/project-directory/add.vue?macro=true";
import { default as addc9aKBimTliQZD_0zT7jvzkWaHH1E53uUnnPJkxDLyOEMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/workflow/add.vue?macro=true";
import { default as addH8kQ2ST5WJNSdAx0nRYAiDZ2tHUvywJ3KCojqTJqAQsMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/wbs/[wbs-id]/projects/add.vue?macro=true";
import { default as addlgRCyxXaIUQ86fS9MzNKTuHhax2qT3WPYo8nK3HF_0gMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/forms/[project-form-id]/submission/add.vue?macro=true";
import { default as updateST00xzwUT0_HfMpbWEiqD_eull73jauqubrZQcO3rsMMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/forms/[project-form-id]/submission/update.vue?macro=true";
import { default as view5wXjPs3wMhXWcQLQCMG9Y1CIQmr0afzVjiVgViCRG8kMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/forms/[project-form-id]/submission/view.vue?macro=true";
import { default as updategdwFDYh76FJXxeEP_zOHCSMN2P1i6KImNq5TMUwZn_AMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/distribution-group/[distribution-group-id]/update.vue?macro=true";
import { default as viewUzMbBMaNaH_g1EUwDRynwNVCcH7AygBUMV46TcAYaacMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/distribution-group/[distribution-group-id]/view.vue?macro=true";
import { default as index872Q4czQ_bultNdKawu3cu2vsKW0ToFNGyrcNQeora4Meta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/forms/[project-form-id]/submission/index.vue?macro=true";
import { default as indexChusFEXZdpm0JhAFJyWV7T8uQA1p7E7NJYCFMSA68WsMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/project-directory/[id]/contacts/index.vue?macro=true";
import { default as updateH2sxneYzzArUc6Ans8WXeK9IqAsR20AE_Zs_ODheCvMMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/project-directory/[id]/update.vue?macro=true";
import { default as viewuponKOztNp5MFg3ccATZkUFR8NfxG6bkA8IDRExSjk4Meta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/project-directory/[id]/view.vue?macro=true";
import { default as updateFYbtG7sEug_RwMuWcGJK2qlycmlqW_eAEW_Ot_MpyPoMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/workflow/[main-workflow-id]/update.vue?macro=true";
import { default as versionsID2ukg66Orj7oi5Yv_zUC73Zjt5I346EWWOu4cZGRMQMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/workflow/[main-workflow-id]/versions.vue?macro=true";
import { default as viewLaXuB_OqVesh71wWsuyTr3AhzrnzFeW51DVNh0PvpoQMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/workflow/[main-workflow-id]/view.vue?macro=true";
import { default as assigneesTgB0JNqZlFTJcOKRNqJRYOSuA0H8qHCh0_AYcq4OVg8Meta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/wbs/[wbs-id]/projects/[project-id]/assignees.vue?macro=true";
import { default as updateeAA6wTJEOKrhagQaFZizCuMhnwjI0QP2heMOOXBhKVAMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/wbs/[wbs-id]/projects/[project-id]/update.vue?macro=true";
import { default as viewJEHaks07WNxYKozmwljG3yyGvk42MNGPC9HVH1DxtosMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/wbs/[wbs-id]/projects/[project-id]/view.vue?macro=true";
import { default as itemsZn_iv3lpGVaonJB8Lbc7x8Qh_Kv8IYpWQMS2RpO8mV8Meta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/custom-lists/[custom-list-id]/items.vue?macro=true";
import { default as index9hQfMea8pGTYWUP_70rGInKXHJyJjDw4k8XaG70L5WIMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/enterprise-directory/[id]/contacts/index.vue?macro=true";
import { default as updatef8UPrGkHmLdTDGenROia4owhQb66RdOMDG10AJ5WSuQMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/enterprise-directory/[id]/update.vue?macro=true";
import { default as viewrEF0NJVIK939FW7Y6ee3j8gbATHx_bqeLywvAGQ7cqMMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/enterprise-directory/[id]/view.vue?macro=true";
import { default as updateRBCoO3nAzn_9TTAh2wJo0D2zVMtlEhz5lCCitQCB0CYMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/forms/[form-id]/update.vue?macro=true";
import { default as versions53wCxUANMEJxSVpq_f5cKzIYzHATrhtlwKHOfnCqCz4Meta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/forms/[form-id]/versions.vue?macro=true";
import { default as view0rzp5Ib24ciFIu20RkyoQv3sNzcGrYGY5DCrC9P_uVcMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/forms/[form-id]/view.vue?macro=true";
import { default as indexxefgUVRDuum1gl2_tuPk0UtWBqz5hDvNtgK9Md6AQq0Meta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/distribution-group/index.vue?macro=true";
import { default as index6FO5G7UJDGRqKAvQt6TlL_YuMPT5DwG7C3NDyecW7GAMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/header-footer/index.vue?macro=true";
import { default as indexGQx5dpZiGzmDC1MeEP6U62_bO0YRbZkvvQ6hEroQEsEMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/project-directory/index.vue?macro=true";
import { default as index_oY731l4_0EZYecL7U8v1Wk5My5WqrHPqmxLwfVggSYMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/workflow/index.vue?macro=true";
import { default as updateMFT1tBHFl3Ra5qrbRWjljkDC7BV6XYxjqbo7dZBGgycMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/roles/[id]/update.vue?macro=true";
import { default as view9uGqutKsm2z1ZeMcGT53xwQ1W0BOVyx5rh_J1ATqbv0Meta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/roles/[id]/view.vue?macro=true";
import { default as updateQC_WYB39eo5xbHAjF_CJC2rXysgW8b9trhFbZtf2DdcMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/users/[userId]/update.vue?macro=true";
import { default as view3jCPA8Hhuk6X_zkHgNxNeZBAAqa2PXZllesbkr_P8wIMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/users/[userId]/view.vue?macro=true";
import { default as indexa3M_ng_9VYsKUvNbczSthyoT04FuI_3UllkUWL2K7Y0Meta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/wbs/[wbs-id]/projects/index.vue?macro=true";
import { default as indexj1_raj6mUpwNWFroPYsZB5gfJvCAG3kD3AFAuzvaI3QMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/dashboard/[dashboard-id]/index.vue?macro=true";
import { default as _91code_93OI20AzqOj8DdYRqqWQNPx7znOS_CgujWpT4BQOk_UwcMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/errors/[code].vue?macro=true";
import { default as index9VXiYQkIbWRMUixm8egggcDD0K7ZFp6uQhWsOXZRrEsMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/index.vue?macro=true";
import { default as _91token_93HSdfSenvrNMPmb65R45BWvkXnIdWYk3CLL_ifTdBndwMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/r/[token].vue?macro=true";
import { default as index2gfsqbz5BtnGIinxawkO_oTnHZczNZhRP2iDVP751ZoMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/custom-lists/index.vue?macro=true";
import { default as index76wndxYy0GPZbG2GM4wLEcHlUDml132ZUcV3tqetfmgMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/enterprise-directory/index.vue?macro=true";
import { default as indexsb4HuFDzh2Ni3ADdFLk9We_NHuEUAGX_II3QBhoF6e4Meta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/forms/index.vue?macro=true";
import { default as index5z10g87Cb_pwJYFtfY6zrvDvrqGqbkGre6XVZEWoSeQMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/modules/index.vue?macro=true";
import { default as notifications0vJfjMR9ZlJOFCR_spZE7knfk7pC4A9P4QA42HisYcQMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/notifications.vue?macro=true";
import { default as indexWWUkJ2fxmgq6CDKfqCDohHyCsKbq9VDLX6_s0jOraJ4Meta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/profile/index.vue?macro=true";
import { default as indexdkguzpDG_JnDOmW5vznZHTl09eP1nyyLDCL6qorpYPQMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/roles/index.vue?macro=true";
import { default as signineiV1_fh2L93n3et8LpPh1gU_CMaje_cyeLON8FrTc0EMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/signin.vue?macro=true";
import { default as testVcM9Ct5vCQYxi1jfO6n7knuWwjhDkUwfG4OugLVmqY0Meta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/test.vue?macro=true";
import { default as index_cI0trxjCYYAzGNVVvak_1jdYSn0e1_3U6_u9jcfe00Meta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/test-workflow/index.vue?macro=true";
import { default as test1Q2uFgJ9KTD6haqrPwnL0DjOgB8PuzF1_k4VyEeHzJ7oMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/test1.vue?macro=true";
import { default as test2isk_4fEMW5TrEQNo6wJWKbQT8MB5RS9KSJ74YwZmwpcMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/test2.vue?macro=true";
import { default as indexdhF6LMShWaeVloi9cP_xKfapvl4W9ZaSO7W9_y22LrgMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/users/index.vue?macro=true";
import { default as indexVjNy2ZgAiq0qY9gFs1rluI0ZbnHsKSBUZcMZ4xCF208Meta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/wbs/index.vue?macro=true";
import { default as workflowTEstYZhD5xmBKXR4su_tVoM8n5BPXPXxoeC0ajopR3bIWEUMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/workflowTEst.vue?macro=true";
import { default as indexnkl3i3EHjrveIogA6yLL9M4Oe_BT_p5lYkHXDheQKccMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/index.vue?macro=true";
import { default as index7VhQSwPmUaIs6NIuhiV0H4INo_WWKG7JV5Q_McPfmRAMeta } from "/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/index.vue?macro=true";
export default [
  {
    name: "auth-login___en",
    path: "/auth/login",
    meta: { ...(login2OIrr2I84f8zuDAn19RARQFnA8jCZYbY3P7TqLb0imsMeta || {}), ...{"middleware":["guest"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/auth/login.vue")
  },
  {
    name: "auth-login___ar",
    path: "/ar/auth/login",
    meta: { ...(login2OIrr2I84f8zuDAn19RARQFnA8jCZYbY3P7TqLb0imsMeta || {}), ...{"middleware":["guest"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/auth/login.vue")
  },
  {
    name: "enterprise-directory-add___en",
    path: "/enterprise-directory/add",
    meta: { ...(addJEemy1zFQOW0LvoKTjPkZUNy1mxu_q1OkOnZQ1CvaMkMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/enterprise-directory/add.vue")
  },
  {
    name: "enterprise-directory-add___ar",
    path: "/ar/enterprise-directory/add",
    meta: { ...(addJEemy1zFQOW0LvoKTjPkZUNy1mxu_q1OkOnZQ1CvaMkMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/enterprise-directory/add.vue")
  },
  {
    name: "examples-fetch-data___en",
    path: "/examples/fetch-data",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/examples/fetch-data.vue")
  },
  {
    name: "examples-fetch-data___ar",
    path: "/ar/examples/fetch-data",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/examples/fetch-data.vue")
  },
  {
    name: "examples-form-1___en",
    path: "/examples/form-1",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/examples/form-1.vue")
  },
  {
    name: "examples-form-1___ar",
    path: "/ar/examples/form-1",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/examples/form-1.vue")
  },
  {
    name: "examples-form-2___en",
    path: "/examples/form-2",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/examples/form-2.vue")
  },
  {
    name: "examples-form-2___ar",
    path: "/ar/examples/form-2",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/examples/form-2.vue")
  },
  {
    name: "forms-add___en",
    path: "/forms/add",
    meta: { ...(add5YeSMbz9XcVDfq1GO5UdjXy6vKi1Xi4_ZGuSmf43SvYMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/forms/add.vue")
  },
  {
    name: "forms-add___ar",
    path: "/ar/forms/add",
    meta: { ...(add5YeSMbz9XcVDfq1GO5UdjXy6vKi1Xi4_ZGuSmf43SvYMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/forms/add.vue")
  },
  {
    name: "roles-add___en",
    path: "/roles/add",
    meta: { ...(addWSBQxyfX_CbJ4E9Ktbj83bLFjjGxocgHow_uY0fHIX0Meta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/roles/add.vue")
  },
  {
    name: "roles-add___ar",
    path: "/ar/roles/add",
    meta: { ...(addWSBQxyfX_CbJ4E9Ktbj83bLFjjGxocgHow_uY0fHIX0Meta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/roles/add.vue")
  },
  {
    name: "users-add___en",
    path: "/users/add",
    meta: { ...(addyIKcbl4t1S_36q_GX1sGnCpPKajehCZmWYu_y2aeM3cMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/users/add.vue")
  },
  {
    name: "users-add___ar",
    path: "/ar/users/add",
    meta: { ...(addyIKcbl4t1S_36q_GX1sGnCpPKajehCZmWYu_y2aeM3cMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/users/add.vue")
  },
  {
    name: "your-work-distribution___en",
    path: "/your-work/distribution",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/distribution.vue")
  },
  {
    name: "your-work-distribution___ar",
    path: "/ar/your-work/distribution",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/distribution.vue")
  },
  {
    name: "your-work-doc-watching___en",
    path: "/your-work/doc-watching",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/doc-watching.vue")
  },
  {
    name: "your-work-doc-watching___ar",
    path: "/ar/your-work/doc-watching",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/doc-watching.vue")
  },
  {
    name: "your-work-escalated-docs___en",
    path: "/your-work/escalated-docs",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/escalated-docs.vue")
  },
  {
    name: "your-work-escalated-docs___ar",
    path: "/ar/your-work/escalated-docs",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/escalated-docs.vue")
  },
  {
    name: "your-work-inbox___en",
    path: "/your-work/inbox",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/inbox.vue")
  },
  {
    name: "your-work-inbox___ar",
    path: "/ar/your-work/inbox",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/inbox.vue")
  },
  {
    name: "your-work-pending-signatures___en",
    path: "/your-work/pending-signatures",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/pending-signatures.vue")
  },
  {
    name: "your-work-pending-signatures___ar",
    path: "/ar/your-work/pending-signatures",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/pending-signatures.vue")
  },
  {
    name: "your-work-rejected-docs___en",
    path: "/your-work/rejected-docs",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/rejected-docs.vue")
  },
  {
    name: "your-work-rejected-docs___ar",
    path: "/ar/your-work/rejected-docs",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/rejected-docs.vue")
  },
  {
    name: "your-work-slot-sla___en",
    path: "/your-work/slot-sla",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/slot-sla.vue")
  },
  {
    name: "your-work-slot-sla___ar",
    path: "/ar/your-work/slot-sla",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/slot-sla.vue")
  },
  {
    name: "your-work-workflow-sla___en",
    path: "/your-work/workflow-sla",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/workflow-sla.vue")
  },
  {
    name: "your-work-workflow-sla___ar",
    path: "/ar/your-work/workflow-sla",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/workflow-sla.vue")
  },
  {
    name: "projects-headerprojectid-distribution-group-add___en",
    path: "/projects/:headerprojectid()/distribution-group/add",
    meta: { ...(adde3dX4Tadrod8nK7sU0onBJKhprUf8c4GTd_CRqwx9mAMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/distribution-group/add.vue")
  },
  {
    name: "projects-headerprojectid-distribution-group-add___ar",
    path: "/ar/projects/:headerprojectid()/distribution-group/add",
    meta: { ...(adde3dX4Tadrod8nK7sU0onBJKhprUf8c4GTd_CRqwx9mAMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/distribution-group/add.vue")
  },
  {
    name: "projects-headerprojectid-project-directory-add___en",
    path: "/projects/:headerprojectid()/project-directory/add",
    meta: { ...(addm0HXnx4JqGrGocZZuelehsJc3NSSATV5m2u8vU49P_wMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/project-directory/add.vue")
  },
  {
    name: "projects-headerprojectid-project-directory-add___ar",
    path: "/ar/projects/:headerprojectid()/project-directory/add",
    meta: { ...(addm0HXnx4JqGrGocZZuelehsJc3NSSATV5m2u8vU49P_wMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/project-directory/add.vue")
  },
  {
    name: "projects-headerprojectid-workflow-add___en",
    path: "/projects/:headerprojectid()/workflow/add",
    meta: { ...(addc9aKBimTliQZD_0zT7jvzkWaHH1E53uUnnPJkxDLyOEMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/workflow/add.vue")
  },
  {
    name: "projects-headerprojectid-workflow-add___ar",
    path: "/ar/projects/:headerprojectid()/workflow/add",
    meta: { ...(addc9aKBimTliQZD_0zT7jvzkWaHH1E53uUnnPJkxDLyOEMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/workflow/add.vue")
  },
  {
    name: "wbs-wbsid-projects-add___en",
    path: "/wbs/:wbsid()/projects/add",
    meta: { ...(addH8kQ2ST5WJNSdAx0nRYAiDZ2tHUvywJ3KCojqTJqAQsMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/wbs/[wbs-id]/projects/add.vue")
  },
  {
    name: "wbs-wbsid-projects-add___ar",
    path: "/ar/wbs/:wbsid()/projects/add",
    meta: { ...(addH8kQ2ST5WJNSdAx0nRYAiDZ2tHUvywJ3KCojqTJqAQsMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/wbs/[wbs-id]/projects/add.vue")
  },
  {
    name: "projects-headerprojectid-forms-projectformid-submission-add___en",
    path: "/projects/:headerprojectid()/forms/:projectformid()/submission/add",
    meta: addlgRCyxXaIUQ86fS9MzNKTuHhax2qT3WPYo8nK3HF_0gMeta || {},
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/forms/[project-form-id]/submission/add.vue")
  },
  {
    name: "projects-headerprojectid-forms-projectformid-submission-add___ar",
    path: "/ar/projects/:headerprojectid()/forms/:projectformid()/submission/add",
    meta: addlgRCyxXaIUQ86fS9MzNKTuHhax2qT3WPYo8nK3HF_0gMeta || {},
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/forms/[project-form-id]/submission/add.vue")
  },
  {
    name: "projects-headerprojectid-forms-projectformid-submission-update___en",
    path: "/projects/:headerprojectid()/forms/:projectformid()/submission/update",
    meta: updateST00xzwUT0_HfMpbWEiqD_eull73jauqubrZQcO3rsMMeta || {},
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/forms/[project-form-id]/submission/update.vue")
  },
  {
    name: "projects-headerprojectid-forms-projectformid-submission-update___ar",
    path: "/ar/projects/:headerprojectid()/forms/:projectformid()/submission/update",
    meta: updateST00xzwUT0_HfMpbWEiqD_eull73jauqubrZQcO3rsMMeta || {},
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/forms/[project-form-id]/submission/update.vue")
  },
  {
    name: "projects-headerprojectid-forms-projectformid-submission-view___en",
    path: "/projects/:headerprojectid()/forms/:projectformid()/submission/view",
    meta: view5wXjPs3wMhXWcQLQCMG9Y1CIQmr0afzVjiVgViCRG8kMeta || {},
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/forms/[project-form-id]/submission/view.vue")
  },
  {
    name: "projects-headerprojectid-forms-projectformid-submission-view___ar",
    path: "/ar/projects/:headerprojectid()/forms/:projectformid()/submission/view",
    meta: view5wXjPs3wMhXWcQLQCMG9Y1CIQmr0afzVjiVgViCRG8kMeta || {},
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/forms/[project-form-id]/submission/view.vue")
  },
  {
    name: "projects-headerprojectid-distribution-group-distributiongroupid-update___en",
    path: "/projects/:headerprojectid()/distribution-group/:distributiongroupid()/update",
    meta: { ...(updategdwFDYh76FJXxeEP_zOHCSMN2P1i6KImNq5TMUwZn_AMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/distribution-group/[distribution-group-id]/update.vue")
  },
  {
    name: "projects-headerprojectid-distribution-group-distributiongroupid-update___ar",
    path: "/ar/projects/:headerprojectid()/distribution-group/:distributiongroupid()/update",
    meta: { ...(updategdwFDYh76FJXxeEP_zOHCSMN2P1i6KImNq5TMUwZn_AMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/distribution-group/[distribution-group-id]/update.vue")
  },
  {
    name: "projects-headerprojectid-distribution-group-distributiongroupid-view___en",
    path: "/projects/:headerprojectid()/distribution-group/:distributiongroupid()/view",
    meta: { ...(viewUzMbBMaNaH_g1EUwDRynwNVCcH7AygBUMV46TcAYaacMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/distribution-group/[distribution-group-id]/view.vue")
  },
  {
    name: "projects-headerprojectid-distribution-group-distributiongroupid-view___ar",
    path: "/ar/projects/:headerprojectid()/distribution-group/:distributiongroupid()/view",
    meta: { ...(viewUzMbBMaNaH_g1EUwDRynwNVCcH7AygBUMV46TcAYaacMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/distribution-group/[distribution-group-id]/view.vue")
  },
  {
    name: "projects-headerprojectid-forms-projectformid-submission___en",
    path: "/projects/:headerprojectid()/forms/:projectformid()/submission",
    meta: index872Q4czQ_bultNdKawu3cu2vsKW0ToFNGyrcNQeora4Meta || {},
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/forms/[project-form-id]/submission/index.vue")
  },
  {
    name: "projects-headerprojectid-forms-projectformid-submission___ar",
    path: "/ar/projects/:headerprojectid()/forms/:projectformid()/submission",
    meta: index872Q4czQ_bultNdKawu3cu2vsKW0ToFNGyrcNQeora4Meta || {},
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/forms/[project-form-id]/submission/index.vue")
  },
  {
    name: "projects-headerprojectid-project-directory-id-contacts___en",
    path: "/projects/:headerprojectid()/project-directory/:id()/contacts",
    meta: { ...(indexChusFEXZdpm0JhAFJyWV7T8uQA1p7E7NJYCFMSA68WsMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/project-directory/[id]/contacts/index.vue")
  },
  {
    name: "projects-headerprojectid-project-directory-id-contacts___ar",
    path: "/ar/projects/:headerprojectid()/project-directory/:id()/contacts",
    meta: { ...(indexChusFEXZdpm0JhAFJyWV7T8uQA1p7E7NJYCFMSA68WsMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/project-directory/[id]/contacts/index.vue")
  },
  {
    name: "projects-headerprojectid-project-directory-id-update___en",
    path: "/projects/:headerprojectid()/project-directory/:id()/update",
    meta: { ...(updateH2sxneYzzArUc6Ans8WXeK9IqAsR20AE_Zs_ODheCvMMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/project-directory/[id]/update.vue")
  },
  {
    name: "projects-headerprojectid-project-directory-id-update___ar",
    path: "/ar/projects/:headerprojectid()/project-directory/:id()/update",
    meta: { ...(updateH2sxneYzzArUc6Ans8WXeK9IqAsR20AE_Zs_ODheCvMMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/project-directory/[id]/update.vue")
  },
  {
    name: "projects-headerprojectid-project-directory-id-view___en",
    path: "/projects/:headerprojectid()/project-directory/:id()/view",
    meta: { ...(viewuponKOztNp5MFg3ccATZkUFR8NfxG6bkA8IDRExSjk4Meta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/project-directory/[id]/view.vue")
  },
  {
    name: "projects-headerprojectid-project-directory-id-view___ar",
    path: "/ar/projects/:headerprojectid()/project-directory/:id()/view",
    meta: { ...(viewuponKOztNp5MFg3ccATZkUFR8NfxG6bkA8IDRExSjk4Meta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/project-directory/[id]/view.vue")
  },
  {
    name: "projects-headerprojectid-workflow-mainworkflowid-update___en",
    path: "/projects/:headerprojectid()/workflow/:mainworkflowid()/update",
    meta: { ...(updateFYbtG7sEug_RwMuWcGJK2qlycmlqW_eAEW_Ot_MpyPoMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/workflow/[main-workflow-id]/update.vue")
  },
  {
    name: "projects-headerprojectid-workflow-mainworkflowid-update___ar",
    path: "/ar/projects/:headerprojectid()/workflow/:mainworkflowid()/update",
    meta: { ...(updateFYbtG7sEug_RwMuWcGJK2qlycmlqW_eAEW_Ot_MpyPoMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/workflow/[main-workflow-id]/update.vue")
  },
  {
    name: "projects-headerprojectid-workflow-mainworkflowid-versions___en",
    path: "/projects/:headerprojectid()/workflow/:mainworkflowid()/versions",
    meta: { ...(versionsID2ukg66Orj7oi5Yv_zUC73Zjt5I346EWWOu4cZGRMQMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/workflow/[main-workflow-id]/versions.vue")
  },
  {
    name: "projects-headerprojectid-workflow-mainworkflowid-versions___ar",
    path: "/ar/projects/:headerprojectid()/workflow/:mainworkflowid()/versions",
    meta: { ...(versionsID2ukg66Orj7oi5Yv_zUC73Zjt5I346EWWOu4cZGRMQMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/workflow/[main-workflow-id]/versions.vue")
  },
  {
    name: "projects-headerprojectid-workflow-mainworkflowid-view___en",
    path: "/projects/:headerprojectid()/workflow/:mainworkflowid()/view",
    meta: { ...(viewLaXuB_OqVesh71wWsuyTr3AhzrnzFeW51DVNh0PvpoQMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/workflow/[main-workflow-id]/view.vue")
  },
  {
    name: "projects-headerprojectid-workflow-mainworkflowid-view___ar",
    path: "/ar/projects/:headerprojectid()/workflow/:mainworkflowid()/view",
    meta: { ...(viewLaXuB_OqVesh71wWsuyTr3AhzrnzFeW51DVNh0PvpoQMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/workflow/[main-workflow-id]/view.vue")
  },
  {
    name: "wbs-wbsid-projects-projectid-assignees___en",
    path: "/wbs/:wbsid()/projects/:projectid()/assignees",
    meta: { ...(assigneesTgB0JNqZlFTJcOKRNqJRYOSuA0H8qHCh0_AYcq4OVg8Meta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/wbs/[wbs-id]/projects/[project-id]/assignees.vue")
  },
  {
    name: "wbs-wbsid-projects-projectid-assignees___ar",
    path: "/ar/wbs/:wbsid()/projects/:projectid()/assignees",
    meta: { ...(assigneesTgB0JNqZlFTJcOKRNqJRYOSuA0H8qHCh0_AYcq4OVg8Meta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/wbs/[wbs-id]/projects/[project-id]/assignees.vue")
  },
  {
    name: "wbs-wbsid-projects-projectid-update___en",
    path: "/wbs/:wbsid()/projects/:projectid()/update",
    meta: { ...(updateeAA6wTJEOKrhagQaFZizCuMhnwjI0QP2heMOOXBhKVAMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/wbs/[wbs-id]/projects/[project-id]/update.vue")
  },
  {
    name: "wbs-wbsid-projects-projectid-update___ar",
    path: "/ar/wbs/:wbsid()/projects/:projectid()/update",
    meta: { ...(updateeAA6wTJEOKrhagQaFZizCuMhnwjI0QP2heMOOXBhKVAMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/wbs/[wbs-id]/projects/[project-id]/update.vue")
  },
  {
    name: "wbs-wbsid-projects-projectid-view___en",
    path: "/wbs/:wbsid()/projects/:projectid()/view",
    meta: { ...(viewJEHaks07WNxYKozmwljG3yyGvk42MNGPC9HVH1DxtosMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/wbs/[wbs-id]/projects/[project-id]/view.vue")
  },
  {
    name: "wbs-wbsid-projects-projectid-view___ar",
    path: "/ar/wbs/:wbsid()/projects/:projectid()/view",
    meta: { ...(viewJEHaks07WNxYKozmwljG3yyGvk42MNGPC9HVH1DxtosMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/wbs/[wbs-id]/projects/[project-id]/view.vue")
  },
  {
    name: "custom-lists-customlistid-items___en",
    path: "/custom-lists/:customlistid()/items",
    meta: { ...(itemsZn_iv3lpGVaonJB8Lbc7x8Qh_Kv8IYpWQMS2RpO8mV8Meta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/custom-lists/[custom-list-id]/items.vue")
  },
  {
    name: "custom-lists-customlistid-items___ar",
    path: "/ar/custom-lists/:customlistid()/items",
    meta: { ...(itemsZn_iv3lpGVaonJB8Lbc7x8Qh_Kv8IYpWQMS2RpO8mV8Meta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/custom-lists/[custom-list-id]/items.vue")
  },
  {
    name: "enterprise-directory-id-contacts___en",
    path: "/enterprise-directory/:id()/contacts",
    meta: { ...(index9hQfMea8pGTYWUP_70rGInKXHJyJjDw4k8XaG70L5WIMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/enterprise-directory/[id]/contacts/index.vue")
  },
  {
    name: "enterprise-directory-id-contacts___ar",
    path: "/ar/enterprise-directory/:id()/contacts",
    meta: { ...(index9hQfMea8pGTYWUP_70rGInKXHJyJjDw4k8XaG70L5WIMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/enterprise-directory/[id]/contacts/index.vue")
  },
  {
    name: "enterprise-directory-id-update___en",
    path: "/enterprise-directory/:id()/update",
    meta: { ...(updatef8UPrGkHmLdTDGenROia4owhQb66RdOMDG10AJ5WSuQMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/enterprise-directory/[id]/update.vue")
  },
  {
    name: "enterprise-directory-id-update___ar",
    path: "/ar/enterprise-directory/:id()/update",
    meta: { ...(updatef8UPrGkHmLdTDGenROia4owhQb66RdOMDG10AJ5WSuQMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/enterprise-directory/[id]/update.vue")
  },
  {
    name: "enterprise-directory-id-view___en",
    path: "/enterprise-directory/:id()/view",
    meta: { ...(viewrEF0NJVIK939FW7Y6ee3j8gbATHx_bqeLywvAGQ7cqMMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/enterprise-directory/[id]/view.vue")
  },
  {
    name: "enterprise-directory-id-view___ar",
    path: "/ar/enterprise-directory/:id()/view",
    meta: { ...(viewrEF0NJVIK939FW7Y6ee3j8gbATHx_bqeLywvAGQ7cqMMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/enterprise-directory/[id]/view.vue")
  },
  {
    name: "forms-formid-update___en",
    path: "/forms/:formid()/update",
    meta: { ...(updateRBCoO3nAzn_9TTAh2wJo0D2zVMtlEhz5lCCitQCB0CYMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/forms/[form-id]/update.vue")
  },
  {
    name: "forms-formid-update___ar",
    path: "/ar/forms/:formid()/update",
    meta: { ...(updateRBCoO3nAzn_9TTAh2wJo0D2zVMtlEhz5lCCitQCB0CYMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/forms/[form-id]/update.vue")
  },
  {
    name: "forms-formid-versions___en",
    path: "/forms/:formid()/versions",
    meta: { ...(versions53wCxUANMEJxSVpq_f5cKzIYzHATrhtlwKHOfnCqCz4Meta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/forms/[form-id]/versions.vue")
  },
  {
    name: "forms-formid-versions___ar",
    path: "/ar/forms/:formid()/versions",
    meta: { ...(versions53wCxUANMEJxSVpq_f5cKzIYzHATrhtlwKHOfnCqCz4Meta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/forms/[form-id]/versions.vue")
  },
  {
    name: "forms-formid-view___en",
    path: "/forms/:formid()/view",
    meta: { ...(view0rzp5Ib24ciFIu20RkyoQv3sNzcGrYGY5DCrC9P_uVcMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/forms/[form-id]/view.vue")
  },
  {
    name: "forms-formid-view___ar",
    path: "/ar/forms/:formid()/view",
    meta: { ...(view0rzp5Ib24ciFIu20RkyoQv3sNzcGrYGY5DCrC9P_uVcMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/forms/[form-id]/view.vue")
  },
  {
    name: "projects-headerprojectid-distribution-group___en",
    path: "/projects/:headerprojectid()/distribution-group",
    meta: { ...(indexxefgUVRDuum1gl2_tuPk0UtWBqz5hDvNtgK9Md6AQq0Meta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/distribution-group/index.vue")
  },
  {
    name: "projects-headerprojectid-distribution-group___ar",
    path: "/ar/projects/:headerprojectid()/distribution-group",
    meta: { ...(indexxefgUVRDuum1gl2_tuPk0UtWBqz5hDvNtgK9Md6AQq0Meta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/distribution-group/index.vue")
  },
  {
    name: "projects-headerprojectid-header-footer___en",
    path: "/projects/:headerprojectid()/header-footer",
    meta: { ...(index6FO5G7UJDGRqKAvQt6TlL_YuMPT5DwG7C3NDyecW7GAMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/header-footer/index.vue")
  },
  {
    name: "projects-headerprojectid-header-footer___ar",
    path: "/ar/projects/:headerprojectid()/header-footer",
    meta: { ...(index6FO5G7UJDGRqKAvQt6TlL_YuMPT5DwG7C3NDyecW7GAMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/header-footer/index.vue")
  },
  {
    name: "projects-headerprojectid-project-directory___en",
    path: "/projects/:headerprojectid()/project-directory",
    meta: { ...(indexGQx5dpZiGzmDC1MeEP6U62_bO0YRbZkvvQ6hEroQEsEMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/project-directory/index.vue")
  },
  {
    name: "projects-headerprojectid-project-directory___ar",
    path: "/ar/projects/:headerprojectid()/project-directory",
    meta: { ...(indexGQx5dpZiGzmDC1MeEP6U62_bO0YRbZkvvQ6hEroQEsEMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/project-directory/index.vue")
  },
  {
    name: "projects-headerprojectid-workflow___en",
    path: "/projects/:headerprojectid()/workflow",
    meta: { ...(index_oY731l4_0EZYecL7U8v1Wk5My5WqrHPqmxLwfVggSYMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/workflow/index.vue")
  },
  {
    name: "projects-headerprojectid-workflow___ar",
    path: "/ar/projects/:headerprojectid()/workflow",
    meta: { ...(index_oY731l4_0EZYecL7U8v1Wk5My5WqrHPqmxLwfVggSYMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/workflow/index.vue")
  },
  {
    name: "roles-id-update___en",
    path: "/roles/:id()/update",
    meta: { ...(updateMFT1tBHFl3Ra5qrbRWjljkDC7BV6XYxjqbo7dZBGgycMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/roles/[id]/update.vue")
  },
  {
    name: "roles-id-update___ar",
    path: "/ar/roles/:id()/update",
    meta: { ...(updateMFT1tBHFl3Ra5qrbRWjljkDC7BV6XYxjqbo7dZBGgycMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/roles/[id]/update.vue")
  },
  {
    name: "roles-id-view___en",
    path: "/roles/:id()/view",
    meta: { ...(view9uGqutKsm2z1ZeMcGT53xwQ1W0BOVyx5rh_J1ATqbv0Meta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/roles/[id]/view.vue")
  },
  {
    name: "roles-id-view___ar",
    path: "/ar/roles/:id()/view",
    meta: { ...(view9uGqutKsm2z1ZeMcGT53xwQ1W0BOVyx5rh_J1ATqbv0Meta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/roles/[id]/view.vue")
  },
  {
    name: "users-userId-update___en",
    path: "/users/:userId()/update",
    meta: { ...(updateQC_WYB39eo5xbHAjF_CJC2rXysgW8b9trhFbZtf2DdcMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/users/[userId]/update.vue")
  },
  {
    name: "users-userId-update___ar",
    path: "/ar/users/:userId()/update",
    meta: { ...(updateQC_WYB39eo5xbHAjF_CJC2rXysgW8b9trhFbZtf2DdcMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/users/[userId]/update.vue")
  },
  {
    name: "users-userId-view___en",
    path: "/users/:userId()/view",
    meta: { ...(view3jCPA8Hhuk6X_zkHgNxNeZBAAqa2PXZllesbkr_P8wIMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/users/[userId]/view.vue")
  },
  {
    name: "users-userId-view___ar",
    path: "/ar/users/:userId()/view",
    meta: { ...(view3jCPA8Hhuk6X_zkHgNxNeZBAAqa2PXZllesbkr_P8wIMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/users/[userId]/view.vue")
  },
  {
    name: "wbs-wbsid-projects___en",
    path: "/wbs/:wbsid()/projects",
    meta: { ...(indexa3M_ng_9VYsKUvNbczSthyoT04FuI_3UllkUWL2K7Y0Meta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/wbs/[wbs-id]/projects/index.vue")
  },
  {
    name: "wbs-wbsid-projects___ar",
    path: "/ar/wbs/:wbsid()/projects",
    meta: { ...(indexa3M_ng_9VYsKUvNbczSthyoT04FuI_3UllkUWL2K7Y0Meta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/wbs/[wbs-id]/projects/index.vue")
  },
  {
    name: "dashboard-dashboardid___en",
    path: "/dashboard/:dashboardid()",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/dashboard/[dashboard-id]/index.vue")
  },
  {
    name: "dashboard-dashboardid___ar",
    path: "/ar/dashboard/:dashboardid()",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/dashboard/[dashboard-id]/index.vue")
  },
  {
    name: "errors-code___en",
    path: "/errors/:code()",
    meta: _91code_93OI20AzqOj8DdYRqqWQNPx7znOS_CgujWpT4BQOk_UwcMeta || {},
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/errors/[code].vue")
  },
  {
    name: "errors-code___ar",
    path: "/ar/errors/:code()",
    meta: _91code_93OI20AzqOj8DdYRqqWQNPx7znOS_CgujWpT4BQOk_UwcMeta || {},
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/errors/[code].vue")
  },
  {
    name: "projects-headerprojectid___en",
    path: "/projects/:headerprojectid()",
    meta: index9VXiYQkIbWRMUixm8egggcDD0K7ZFp6uQhWsOXZRrEsMeta || {},
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/index.vue")
  },
  {
    name: "projects-headerprojectid___ar",
    path: "/ar/projects/:headerprojectid()",
    meta: index9VXiYQkIbWRMUixm8egggcDD0K7ZFp6uQhWsOXZRrEsMeta || {},
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/projects/[header-project-id]/index.vue")
  },
  {
    name: "r-token___en",
    path: "/r/:token()",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/r/[token].vue")
  },
  {
    name: "r-token___ar",
    path: "/ar/r/:token()",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/r/[token].vue")
  },
  {
    name: "custom-lists___en",
    path: "/custom-lists",
    meta: { ...(index2gfsqbz5BtnGIinxawkO_oTnHZczNZhRP2iDVP751ZoMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/custom-lists/index.vue")
  },
  {
    name: "custom-lists___ar",
    path: "/ar/custom-lists",
    meta: { ...(index2gfsqbz5BtnGIinxawkO_oTnHZczNZhRP2iDVP751ZoMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/custom-lists/index.vue")
  },
  {
    name: "enterprise-directory___en",
    path: "/enterprise-directory",
    meta: { ...(index76wndxYy0GPZbG2GM4wLEcHlUDml132ZUcV3tqetfmgMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/enterprise-directory/index.vue")
  },
  {
    name: "enterprise-directory___ar",
    path: "/ar/enterprise-directory",
    meta: { ...(index76wndxYy0GPZbG2GM4wLEcHlUDml132ZUcV3tqetfmgMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/enterprise-directory/index.vue")
  },
  {
    name: "forms___en",
    path: "/forms",
    meta: { ...(indexsb4HuFDzh2Ni3ADdFLk9We_NHuEUAGX_II3QBhoF6e4Meta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/forms/index.vue")
  },
  {
    name: "forms___ar",
    path: "/ar/forms",
    meta: { ...(indexsb4HuFDzh2Ni3ADdFLk9We_NHuEUAGX_II3QBhoF6e4Meta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/forms/index.vue")
  },
  {
    name: "modules___en",
    path: "/modules",
    meta: { ...(index5z10g87Cb_pwJYFtfY6zrvDvrqGqbkGre6XVZEWoSeQMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/modules/index.vue")
  },
  {
    name: "modules___ar",
    path: "/ar/modules",
    meta: { ...(index5z10g87Cb_pwJYFtfY6zrvDvrqGqbkGre6XVZEWoSeQMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/modules/index.vue")
  },
  {
    name: "notifications___en",
    path: "/notifications",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/notifications.vue")
  },
  {
    name: "notifications___ar",
    path: "/ar/notifications",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/notifications.vue")
  },
  {
    name: "profile___en",
    path: "/profile",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/profile/index.vue")
  },
  {
    name: "profile___ar",
    path: "/ar/profile",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/profile/index.vue")
  },
  {
    name: "roles___en",
    path: "/roles",
    meta: { ...(indexdkguzpDG_JnDOmW5vznZHTl09eP1nyyLDCL6qorpYPQMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/roles/index.vue")
  },
  {
    name: "roles___ar",
    path: "/ar/roles",
    meta: { ...(indexdkguzpDG_JnDOmW5vznZHTl09eP1nyyLDCL6qorpYPQMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/roles/index.vue")
  },
  {
    name: "signin___en",
    path: "/signin",
    meta: { ...(signineiV1_fh2L93n3et8LpPh1gU_CMaje_cyeLON8FrTc0EMeta || {}), ...{"middleware":["signin-compat"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/signin.vue")
  },
  {
    name: "signin___ar",
    path: "/ar/signin",
    meta: { ...(signineiV1_fh2L93n3et8LpPh1gU_CMaje_cyeLON8FrTc0EMeta || {}), ...{"middleware":["signin-compat"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/signin.vue")
  },
  {
    name: "test___en",
    path: "/test",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/test.vue")
  },
  {
    name: "test___ar",
    path: "/ar/test",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/test.vue")
  },
  {
    name: "test-workflow___en",
    path: "/test-workflow",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/test-workflow/index.vue")
  },
  {
    name: "test-workflow___ar",
    path: "/ar/test-workflow",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/test-workflow/index.vue")
  },
  {
    name: "test1___en",
    path: "/test1",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/test1.vue")
  },
  {
    name: "test1___ar",
    path: "/ar/test1",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/test1.vue")
  },
  {
    name: "test2___en",
    path: "/test2",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/test2.vue")
  },
  {
    name: "test2___ar",
    path: "/ar/test2",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/test2.vue")
  },
  {
    name: "users___en",
    path: "/users",
    meta: { ...(indexdhF6LMShWaeVloi9cP_xKfapvl4W9ZaSO7W9_y22LrgMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/users/index.vue")
  },
  {
    name: "users___ar",
    path: "/ar/users",
    meta: { ...(indexdhF6LMShWaeVloi9cP_xKfapvl4W9ZaSO7W9_y22LrgMeta || {}), ...{"middleware":["permission"]} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/users/index.vue")
  },
  {
    name: "wbs___en",
    path: "/wbs",
    meta: { ...(indexVjNy2ZgAiq0qY9gFs1rluI0ZbnHsKSBUZcMZ4xCF208Meta || {}), ...{"middleware":"permission"} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/wbs/index.vue")
  },
  {
    name: "wbs___ar",
    path: "/ar/wbs",
    meta: { ...(indexVjNy2ZgAiq0qY9gFs1rluI0ZbnHsKSBUZcMZ4xCF208Meta || {}), ...{"middleware":"permission"} },
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/wbs/index.vue")
  },
  {
    name: "workflowTEst___en",
    path: "/workflowTEst",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/workflowTEst.vue")
  },
  {
    name: "workflowTEst___ar",
    path: "/ar/workflowTEst",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/workflowTEst.vue")
  },
  {
    name: "your-work___en",
    path: "/your-work",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/index.vue")
  },
  {
    name: "your-work___ar",
    path: "/ar/your-work",
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/your-work/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: {"middleware":"redirect"},
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    meta: {"middleware":"redirect"},
    component: () => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/pages/index.vue")
  }
]